import { clamp } from '@ui/style/clamp-calculator';
import { centered } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { bottomNavigation, headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
const useHomeStyles = () => {
    const { isMobile, isMobileIpadNavigation } = useResponsive();
    const cardContainerHeight = `${spaceAboveHeader + headerHeight + spaceBelowHeader}px`;
    const cardContainerHeightMobile = `${headerHeight + spaceAboveHeader + bottomNavigation}px`;
    return {
        main: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            height: isMobileIpadNavigation
                ? `calc(100dvh -  ${cardContainerHeightMobile})`
                : `calc(100dvh -  ${cardContainerHeight})`,
            overflowY: 'auto',
            pb: { xs: 1, sm: 0 },
            px: isMobileIpadNavigation ? 0 : clamp.calculate(8, 32)
        },
        contentContainer: {
            flexGrow: 1,
            px: isMobile ? 1 : undefined,
            margin: 'auto',
            textAlign: 'center',
            gap: { xs: 1, sm: 3 },
            ...centered,
            flexDirection: 'column'
        },
        span: {
            fontWeight: 700
        },
        typography: {
            fontWeight: 400,
            color: 'text.primary'
        }
    };
};
export default useHomeStyles;
